import { getUserLoginMenuList } from '@/api/common/common';

export const state = {
    authMenus: [],
};

export const getters = {
    getAuthMenus: state => state.authMenus,
};

export const mutations = {
    setAuthMenus(state, payload) {
        state.authMenus=[...payload];
    },
};

export const actions = {
    selectAuthMenus({ commit }) {
        getUserLoginMenuList(this.email).then(res => {
            if (res.status != '200') {
                alert("처리중 에러가 발생하였습니다.");
                return;
            }
            commit('setAuthMenus', res.data.cmmData);
        })
    }
};
